import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import axios from "../../components/api/axios";
import ContractsModel from "../../models/contracts";

export default class ContractsRepository extends BaseRepository {
  static modelClass = ContractsModel;
  modelName = "contracts";

  async createWithPayment(formData) {
    return await axios.post("/api/contracts/create_with_payment/", formData);
  }
}
